import React from "react";
import { Box } from "reflexbox";

export function PresetButton({ preset, SelectedPresetsState }) {
	let [selectedPreset, setSelectedPreset] = SelectedPresetsState;

	return (
		<Box m={1} key={preset.name}>
			<button
				className="btn btn-light  text-left"
				type="button"
				onClick={() => {
					setSelectedPreset(preset.name);
				}}
			>
				{preset.name} {selectedPreset === preset.name && "*"}
			</button>
		</Box>
	);
}
